import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/45 backdrop-blur-md shadow-soft border-b border-white/40' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <button type="button" className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')} aria-label="Accueil">
            <img src="/assets/Logo_EAM.png" alt="EUDORA AROMAS MADAGASCAR" className="h-12 w-auto filter drop-shadow-sm" />
            <div>
              <h1 className="font-display text-lg lg:text-xl font-bold gradient-text leading-tight">EUDORA AROMAS</h1>
              <p className="text-xs hidden sm:block mt-0.5 font-medium text-coffee-100">MADAGASCAR</p>
            </div>
          </button>

          <nav className="hidden lg:flex items-center space-x-8" aria-label="Navigation principale">
            {(['story', 'products', 'process', 'contact'] as const).map((id) => (
              <button key={id} type="button" onClick={() => scrollToSection(id)} className="text-coffee-200 hover:text-forest-200 transition-colors duration-300 font-medium relative group">
                {t(`navigation.${id}`)}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-forest-200 transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <LanguageSwitch />
            <button type="button" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden w-10 h-10 flex items-center justify-center text-coffee-200" aria-expanded={isMobileMenuOpen} aria-label="Menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 py-4 border-t border-cream-200 bg-cream-50/95 backdrop-blur-sm rounded-2xl shadow-soft">
            {(['story', 'products', 'process', 'contact'] as const).map((id) => (
              <button key={id} type="button" onClick={() => scrollToSection(id)} className="block w-full text-left px-4 py-2 text-coffee-200 hover:text-forest-200 hover:bg-cream-100 rounded-lg font-medium">{t(`navigation.${id}`)}</button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
